import { render, staticRenderFns } from "./Cliente_articulo.vue?vue&type=template&id=43b68714&scoped=true&"
import script from "./Cliente_articulo.vue?vue&type=script&lang=js&"
export * from "./Cliente_articulo.vue?vue&type=script&lang=js&"
import style0 from "./Cliente_articulo.vue?vue&type=style&index=0&id=43b68714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b68714",
  null
  
)

export default component.exports